import React, { useState, useEffect } from 'react';
import {
    StoryTimeModalOverlay,
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    SpinningIcon
} from './StoryTimeElements';

const StoryTimeModal = ({ isOpen, onClose, onSave }) => {
    const [step, setStep] = useState(1);
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [formData, setFormData] = useState({
        id: crypto.randomUUID(),
        title: '',
        setting: '',
        characters: '',
        details: '',
        img: ''
    });

    useEffect(() => {
        const data = localStorage.getItem('story_time.json');
        // console.log(data)
        if (data) {
            setFormData(JSON.parse(data));
        }
    }, []);

    const handleNext = () => setStep(step + 1);
    const handlePrevious = () => setStep(step - 1);

    const handleReset = () => {
        setFormData({
            id: crypto.randomUUID(),
            title: '',
            setting: '',
            characters: '',
            details: '',
        })
        setStep(1);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            setLoadingBoolean(true);
            await onSave(formData); // Updated to match the function name
            // console.log(formData);
        } catch (error) {
            console.error('Save failed', error);
        } finally {
            setLoadingBoolean(false);
        }
    };


    if (!isOpen) return null;

    return (
        <StoryTimeModalOverlay>
            <ModalContainer>
                <ModalHeader>Create New Story</ModalHeader>
                <ModalBody>
                    {step === 1 && (
                        <>
                            <ModalFormLabel>Title (Optional):</ModalFormLabel>
                            <ModalForm type="text" name="title" value={formData.title} onChange={handleChange} />
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <ModalFormLabel>Setting:</ModalFormLabel>
                            <ModalTextArea type="text" name="setting" value={formData.setting} onChange={handleChange} />
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <ModalFormLabel>Character Descriptions:</ModalFormLabel>
                            <ModalTextArea type="text" name="characters" value={formData.characters} onChange={handleChange} />
                        </>
                    )}
                    {step === 4 && (
                        <>
                            <ModalFormLabel>Other Details:</ModalFormLabel>
                            <ModalTextArea type="text" name="details" value={formData.details} onChange={handleChange} />
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <ModalCloseButton onClick={onClose}>Close</ModalCloseButton>
                    <ModalCloseButton onClick={handleReset}>Reset</ModalCloseButton>
                    {step > 1 && <ModalButton onClick={handlePrevious}>Previous</ModalButton>}
                    {step < 4 ? (
                        <ModalButton onClick={handleNext}>Next</ModalButton>
                    ) : (
                        <>
                            {loadingBoolean && (
                                <SpinningIcon />
                            )}
                            <ModalButton onClick={handleSave}>Save</ModalButton>
                        </>
                    )}
                </ModalFooter>
            </ModalContainer>
        </StoryTimeModalOverlay>
    );
};

export default StoryTimeModal;
